export default "__VITE_PUBLIC_ASSET__c277855c__"